// extracted by mini-css-extract-plugin
var _1 = "DocumentTableRow-moduleDocumentTableCell__tZXgq TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "DocumentTableRow-moduleDocumentTableRow__SH20z TableComponent-modulerow__xPAo4";
var _3 = "DocumentTableRow-moduleDroppableItem__vr2aD";
var _4 = "DocumentTableRow-modulecellText__ML_oG TableCellText-moduleTableCellText__b5epO";
var _5 = "DocumentTableRow-moduleuploading__BHesy";
export { _1 as "DocumentTableCell", _2 as "DocumentTableRow", _3 as "DroppableItem", _4 as "cellText", _5 as "uploading" }
